/**
 * Maps proposal client form values to the POST /client payload.
 * Field names align with common CRM patterns; adjust if backend contract differs.
 */

import { getUser } from '../services/authApi';

function trimOrEmpty(v) {
  if (v == null) return '';
  return String(v).trim();
}

/**
 * Backend Client model requires `created_by` (Lead Owner / Created By).
 * See vacspl-backend/modals/ClientModal.js — shape: { employee_name, employee_id }.
 */
function getCreatedByFromSession() {
  const user = getUser();
  if (!user) return null;
  const employeeId = user.employee_id || user.employeeId || '';
  const employeeName =
    user.full_name ||
    user.fullName ||
    user.user_name ||
    user.userName ||
    user.name ||
    employeeId ||
    '';
  if (!employeeId && !employeeName) return null;
  return {
    employee_id: employeeId,
    employee_name: employeeName,
  };
}

/**
 * @param {Object} data — ClientAddForm values (camelCase UI shape)
 * @returns {Object} JSON body for API.addClient
 */
export function getAddClientPayload(data) {
  const companyName = trimOrEmpty(data.companyName);
  const companyAddress = trimOrEmpty(data.companyAddress);
  const city = trimOrEmpty(data.city);
  const state = trimOrEmpty(data.state);
  const companyEmail = trimOrEmpty(data.companyEmail);
  const concernedPersonName = trimOrEmpty(data.concernedPersonName);
  const concernedPersonMobile = trimOrEmpty(data.concernedPersonMobile);
  const concernedPersonEmail = trimOrEmpty(data.concernedPersonEmail);
  const concernedPersonDesignation = trimOrEmpty(data.concernedPersonDesignation);
  const dateOfDiscussion = trimOrEmpty(data.dateOfDiscussion);

  const createdBy = data.created_by || getCreatedByFromSession();

  return {
    client_name: companyName,
    company_address: companyAddress,
    city,
    state,
    client_email: companyEmail,
    contact_person_name: concernedPersonName,
    contact_person_mobile: concernedPersonMobile,
    contact_person_email: concernedPersonEmail,
    contact_person_designation: concernedPersonDesignation,
    ...(dateOfDiscussion ? { discussion_date: dateOfDiscussion } : {}),
    ...(createdBy ? { created_by: createdBy } : {}),
  };
}

/** Namespace for payload helpers */
export const apiControllers = {
  getAddClientPayload,
};
